import * as z from 'zod';

export const NumericIdSchema = z.number();
export type NumericId = z.infer<typeof NumericIdSchema>;
